import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import { BANNER_CONTENT } from '@blueberry/constants/utm';

export const storePreviousLocation = createAction('STORE_PREVIOUS_LOCATION');
export const storeCurrentLocation = createAction('STORE_CURRENT_LOCATION');

const INIT_STATE = {
  previous: '/',
  current: '/',
  appsflyer: {
    pid: '',
    c: '',
  },
  inapp: {
    inapp: '',
    device: '',
    region: '',
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    utmContent: '',
    id: '',
    source: '',
  },
  isWizmo: false,
};

const reducer = handleActions(
  {
    [storePreviousLocation]: (state, action) => ({
      ...state,
      previous: action.payload,
    }),
    [storeCurrentLocation]: (state, action) => ({
      ...state,
      current: action.payload,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getPreviousRoute = state => state.location.previous;
export const getAppsflyerQuery = state => state.location.appsflyer;
export const getInappQuery = state => state.location.inapp;
export const getIsInapp = createSelector(getInappQuery, data => data.inapp);
export const getIsIAB = createSelector(
  [getInappQuery, getIsInapp],
  (data, isInapp) => isInapp && data.source === BANNER_CONTENT
);
export const getCurrentRoute = state => state.location.current;
export const getIsWizmo = state => state.location.isWizmo;



// WEBPACK FOOTER //
// ./app/redux/location.js